export default __webpack_public_path__ + "static/media/_MG_8840.d09ec0c7.jpg";